import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { EFrequency, TOnSubmitSaveSearchParams } from '../../../../packages/SaveSearchModal';
import { getSiteType } from '../../utils/analytics';

export const trackSuburbanSaveSearchModalOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'open',
    category: 'saved_search',
    label: 'window',
  });
};

export const trackSuburbanSaveSearchModalClose = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'close',
    category: 'saved_search',
    label: 'window',
  });
};

type TTrackSuburbanSaveSearchSubscribed = TOnSubmitSaveSearchParams & {
  deviceType: TDevice;
  queryString: string;
};

enum EFilledEmail {
  /** Равен стандартному емейлу */
  Default = 0,
  /** Введен пользователем */
  Custom = 2,
}

const notificationFrequencyMap: Record<EFrequency, string> = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export const trackSuburbanSaveSearchSubscribed = ({
  frequency,
  subscribeToNews,
  title,
  email,
  defaultEmail,
  defaultTitle,
  deviceType,
  queryString,
}: TTrackSuburbanSaveSearchSubscribed) => {
  const filledTitle = title === defaultTitle ? `auto_${defaultTitle}` : title;

  const filledEmail = email === defaultEmail ? EFilledEmail.Default : EFilledEmail.Custom;

  ca('eventSite', {
    name: 'oldevent',
    category: 'saved_search',
    action: 'show',
    label: 'success',
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      queryString,
      extra: {
        not_freq: notificationFrequencyMap[frequency],
        not_yes: subscribeToNews ? 1 : 0,
        filled: {
          title: filledTitle,
          email: filledEmail,
        },
      },
    },
  });
};
